import { render } from "./WalletConnectPage.vue?vue&type=template&id=03a66cb2&scoped=true"
import script from "./WalletConnectPage.vue?vue&type=script&lang=js"
export * from "./WalletConnectPage.vue?vue&type=script&lang=js"

import "./WalletConnectPage.vue?vue&type=style&index=0&id=03a66cb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a66cb2"]])

export default __exports__